import {
  ApiSavedPortfolio,
  useGetByTenantAccountAndAccountSourceAccountIdentifierQuery
} from 'api/rtk-api'
import { Card, DownloadLink, LabelValueRow, Tabs } from 'components/core-v2'
import { Navigate, Route, Routes, useParams } from 'react-router-dom'

import { PATH, TENANT } from '@/const'
import {
  getFactsheetDate,
  onDownloadFactSheetClick,
  onDownloadPortfolioExcelClick
} from '@/utilities'

import { Loading } from './loading'
import { PortfolioAssetsBreakdown } from './portfolio-assets-breakdown'
import { PortfolioAssetsOverview } from './portfolio-assets-overview'

const typeMap = {
  None: 'None',
  ModelPortfolio: 'Model',
  SelfSelect: 'Self select',
  FundOfFunds: 'Fund of funds'
}

export const DetailsPortfolioTab = () => {
  const { '*': splat, source, tradeId } = useParams()
  const [tab] = splat.split('/')
  const { data, isLoading } = useGetByTenantAccountAndAccountSourceAccountIdentifierQuery({
    tenant: TENANT,
    accountIdentifier: tradeId,
    accountSource: source
  })

  if (isLoading) return <Loading />

  const { portfolio } = data.account
  const { rebalancingDefinition, type } = portfolio
  const {
    multiplier,
    portfolioId,
    portfolioName: name,
    taxClassification
  } = portfolio as unknown as ApiSavedPortfolio
  const hasMultiplier = multiplier !== undefined

  const todaysDate = new Date()

  return (
    <Tabs.Panel value="portfolio">
      <Card.Wrapper>
        <LabelValueRow
          label={getFactsheetDate(todaysDate).displayDate}
          value={
            <DownloadLink onClick={() => onDownloadFactSheetClick(portfolioId)}>
              Portfolio Factsheet.pdf
            </DownloadLink>
          }
        />
        {(type === 'ModelPortfolio' || type === 'FundOfFunds') && (
          <LabelValueRow
            label="Daily performance"
            value={
              <DownloadLink onClick={() => onDownloadPortfolioExcelClick(portfolioId, name)}>
                Daily performance data.xlsx
              </DownloadLink>
            }
          />
        )}
      </Card.Wrapper>

      <Card.Wrapper className="mt-12">
        <LabelValueRow label="Type" value={typeMap[type]} />
        {name && <LabelValueRow label="Name" value={name} />}
        <LabelValueRow label="Rebalancing" value={rebalancingDefinition.type} />
        <LabelValueRow
          label="Tax classification"
          showBottomBorder={!hasMultiplier}
          value={taxClassification}
        />
        {hasMultiplier && (
          <LabelValueRow showBottomBorder label="Portfolio multiplier" value={multiplier} />
        )}
      </Card.Wrapper>

      <Card.Wrapper className="mt-12">
        <Tabs.List spacing="md">
          <Tabs.Tab
            isSelected={tab === 'overview'}
            to={PATH.reportsSingleTradeDetailsPortfolioOverview(source, tradeId)}
            value="overview"
          >
            Assets overview
          </Tabs.Tab>
          <Tabs.Tab
            isSelected={tab === 'breakdown'}
            to={PATH.reportsSingleTradeDetailsPortfolioBreakdown(source, tradeId)}
            value="breakdown"
          >
            Assets breakdown
          </Tabs.Tab>
        </Tabs.List>
        <Routes>
          <Route
            element={
              <Navigate to={PATH.reportsSingleTradeDetailsPortfolioOverview(source, tradeId)} />
            }
            path=""
          />
          <Route element={<PortfolioAssetsOverview />} path="overview" />
          <Route element={<PortfolioAssetsBreakdown />} path="breakdown" />
        </Routes>
      </Card.Wrapper>
    </Tabs.Panel>
  )
}
